/**
 * @generated SignedSource<<7beaed222a5e20b672e9c353dbf5ffbf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookActionEnum = "book_delete" | "book_rescrap" | "book_scrap_create" | "book_scraps_classification" | "book_submit" | "book_update" | "scrap_source_book_create" | "%future added value";
export type BookStatusEnum = "completed" | "ongoing" | "%future added value";
export type BookTypeEnum = "normal" | "school" | "%future added value";
export type Ordering = "ASC" | "ASC_NULLS_FIRST" | "ASC_NULLS_LAST" | "DESC" | "DESC_NULLS_FIRST" | "DESC_NULLS_LAST" | "%future added value";
export type SchoolTypeEnum = "elementary_school" | "high_school" | "middle_school" | "%future added value";
export type BookFilter = {
  AND?: BookFilter | null;
  DISTINCT?: boolean | null;
  NOT?: BookFilter | null;
  OR?: BookFilter | null;
  id?: string | null;
  id_Exact?: string | null;
  id_In?: ReadonlyArray<string> | null;
  id_Not_In?: ReadonlyArray<string> | null;
  publisher_In?: ReadonlyArray<string> | null;
  search?: string | null;
  status_Exact?: BookStatusEnum | null;
  status_In?: ReadonlyArray<BookStatusEnum> | null;
  submittedBy_In?: ReadonlyArray<string> | null;
  type_Exact?: BookTypeEnum | null;
  type_In?: ReadonlyArray<BookTypeEnum> | null;
  unitAId_Exact?: string | null;
  unitAId_In?: ReadonlyArray<string> | null;
  unitId_Exact?: string | null;
  unitId_In?: ReadonlyArray<string> | null;
  unitSchoolType_Exact?: SchoolTypeEnum | null;
  unitSchoolType_In?: ReadonlyArray<SchoolTypeEnum> | null;
  unitTitle_Contains?: string | null;
};
export type BookOrder = {
  created?: Ordering | null;
  id?: Ordering | null;
  sequence?: Ordering | null;
  title?: Ordering | null;
};
export type BookId_bookQuery$variables = {
  filters?: BookFilter | null;
  id: string;
  order?: BookOrder | null;
};
export type BookId_bookQuery$data = {
  readonly book: {
    readonly actions: ReadonlyArray<BookActionEnum>;
    readonly coverPdf: {
      readonly key: string;
      readonly objectUrl: string;
    };
    readonly id: string;
    readonly mathkingSyncFailed: boolean;
    readonly next: string | null;
    readonly previous: string | null;
    readonly problemPdf: {
      readonly key: string;
      readonly objectUrl: string;
    };
    readonly sequence: number;
    readonly solutionPdf: {
      readonly key: string;
      readonly objectUrl: string;
    };
    readonly status: BookStatusEnum;
    readonly title: string;
    readonly unclassifiedBookScrapCount: number;
    readonly " $fragmentSpreads": FragmentRefs<"BookActionsMutationButtonStack_book" | "BookBookScrapCreateDialog_book" | "BookBookScrapDeleteDialog_book" | "BookBookScrapPaginator_book" | "BookBookScrapsClassificationDialog_book" | "BookDescriptionList_book" | "BookUpdateDialog_book">;
  };
};
export type BookId_bookQuery = {
  response: BookId_bookQuery$data;
  variables: BookId_bookQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "order"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequence",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actions",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mathkingSyncFailed",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unclassifiedBookScrapCount",
  "storageKey": null
},
v10 = [
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  }
],
v11 = {
  "alias": null,
  "args": (v10/*: any*/),
  "kind": "ScalarField",
  "name": "previous",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": (v10/*: any*/),
  "kind": "ScalarField",
  "name": "next",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "objectUrl",
  "storageKey": null
},
v16 = [
  (v14/*: any*/),
  (v15/*: any*/)
],
v17 = [
  (v14/*: any*/),
  (v15/*: any*/),
  (v4/*: any*/)
],
v18 = [
  (v4/*: any*/),
  (v13/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "problemBookPage",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "solutionBookPage",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "problemNumber",
  "storageKey": null
},
v23 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "picture",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isDeleted",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BookId_bookQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Book",
        "kind": "LinkedField",
        "name": "book",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "coverPdf",
            "plural": false,
            "selections": (v16/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "problemPdf",
            "plural": false,
            "selections": (v16/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "solutionPdf",
            "plural": false,
            "selections": (v16/*: any*/),
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BookUpdateDialog_book"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BookBookScrapDeleteDialog_book"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BookDescriptionList_book"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BookActionsMutationButtonStack_book"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BookBookScrapPaginator_book"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BookBookScrapCreateDialog_book"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BookBookScrapsClassificationDialog_book"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "BookId_bookQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Book",
        "kind": "LinkedField",
        "name": "book",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "coverPdf",
            "plural": false,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "problemPdf",
            "plural": false,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "solutionPdf",
            "plural": false,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UnitA",
            "kind": "LinkedField",
            "name": "unitAs",
            "plural": true,
            "selections": (v18/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publisher",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "edition",
            "storageKey": null
          },
          {
            "alias": "bookScrapCount",
            "args": null,
            "concreteType": "BookScrapConnection",
            "kind": "LinkedField",
            "name": "bookScraps",
            "plural": false,
            "selections": [
              (v19/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BookScrapConnection",
            "kind": "LinkedField",
            "name": "bookScraps",
            "plural": false,
            "selections": [
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BookScrapEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BookScrap",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v7/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "difficultyLevel",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnitD",
                        "kind": "LinkedField",
                        "name": "unitD",
                        "plural": false,
                        "selections": (v18/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "connection",
            "key": "BookBookScrapPaginator_book_bookScraps",
            "kind": "LinkedHandle",
            "name": "bookScraps"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": (v23/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "submittedBy",
            "plural": false,
            "selections": (v23/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "created",
            "storageKey": null
          },
          {
            "alias": "latestBookScraps",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              },
              {
                "kind": "Literal",
                "name": "order",
                "value": {
                  "created": "DESC"
                }
              }
            ],
            "concreteType": "BookScrapConnection",
            "kind": "LinkedField",
            "name": "bookScraps",
            "plural": false,
            "selections": [
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BookScrapEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BookScrap",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "problemPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "solutionPage",
                        "storageKey": null
                      },
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "bookScraps(first:1,order:{\"created\":\"DESC\"})"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "81765421629837a064798eb909cfbb1a",
    "id": null,
    "metadata": {},
    "name": "BookId_bookQuery",
    "operationKind": "query",
    "text": "query BookId_bookQuery(\n  $id: ID!\n  $filters: BookFilter\n  $order: BookOrder\n) {\n  book(id: $id) {\n    id\n    sequence\n    status\n    actions\n    mathkingSyncFailed\n    unclassifiedBookScrapCount\n    previous(order: $order, filters: $filters)\n    next(order: $order, filters: $filters)\n    title\n    coverPdf {\n      key\n      objectUrl\n      id\n    }\n    problemPdf {\n      key\n      objectUrl\n      id\n    }\n    solutionPdf {\n      key\n      objectUrl\n      id\n    }\n    ...BookUpdateDialog_book\n    ...BookBookScrapDeleteDialog_book\n    ...BookDescriptionList_book\n    ...BookActionsMutationButtonStack_book\n    ...BookBookScrapPaginator_book\n    ...BookBookScrapCreateDialog_book\n    ...BookBookScrapsClassificationDialog_book\n  }\n}\n\nfragment BookActionsMutationButtonStack_book on Book {\n  id\n  actions\n}\n\nfragment BookBookScrapCreateDialog_book on Book {\n  id\n  title\n  solutionPdf {\n    id\n    objectUrl\n  }\n  problemPdf {\n    id\n    objectUrl\n  }\n  latestBookScraps: bookScraps(order: {created: DESC}, first: 1) {\n    totalCount\n    edges {\n      node {\n        id\n        problemPage\n        solutionPage\n        problemBookPage\n        solutionBookPage\n        problemNumber\n      }\n    }\n  }\n}\n\nfragment BookBookScrapDeleteDialog_book on Book {\n  id\n  title\n  ...BookBookScrapPaginator_book_W0t7T\n}\n\nfragment BookBookScrapPaginator_book on Book {\n  id\n  bookScraps {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        id\n        actions\n        problemBookPage\n        solutionBookPage\n        problemNumber\n        __typename\n      }\n    }\n    ...BookScrapConnectionDataTable_bookScrapConnection\n  }\n}\n\nfragment BookBookScrapPaginator_book_W0t7T on Book {\n  id\n  bookScraps {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        id\n        actions\n        problemBookPage\n        solutionBookPage\n        problemNumber\n        __typename\n      }\n    }\n    ...BookScrapConnectionDataTable_bookScrapConnection\n  }\n}\n\nfragment BookBookScrapsClassificationDialog_book on Book {\n  id\n  unclassifiedBookScrapCount\n}\n\nfragment BookDescriptionList_book on Book {\n  type\n  title\n  unitAs {\n    id\n    title\n  }\n  publisher\n  edition\n  ...BookStatusLabel_book\n  createdBy {\n    id\n    ...UserAvatarText_user\n  }\n  submittedBy {\n    id\n    ...UserAvatarText_user\n  }\n  created\n}\n\nfragment BookScrapConnectionDataTable_bookScrapConnection on BookScrapConnection {\n  totalCount\n  edges {\n    node {\n      id\n      actions\n      problemNumber\n      problemBookPage\n      solutionBookPage\n      difficultyLevel\n      unitD {\n        id\n        title\n      }\n    }\n  }\n}\n\nfragment BookStatusLabel_book on Book {\n  status\n}\n\nfragment BookUpdateDialog_book on Book {\n  id\n  type\n  title\n  unitAs {\n    id\n  }\n  publisher\n  edition\n  coverPdf {\n    key\n    objectUrl\n    id\n  }\n  problemPdf {\n    key\n    objectUrl\n    id\n  }\n  solutionPdf {\n    key\n    objectUrl\n    id\n  }\n  bookScrapCount: bookScraps {\n    totalCount\n  }\n}\n\nfragment UserAvatarText_user on User {\n  name\n  picture\n  isDeleted\n}\n"
  }
};
})();

(node as any).hash = "2c8120dbb6f480fa99700ed57ed1f6e5";

export default node;
